import { onMounted, onUnmounted } from 'vue'

// Global keyboard-shortcut dispatcher. Single keys only (no modifiers) so nothing
// ever collides with a browser/OS shortcut — see CLAUDE.md-adjacent design notes
// in the App.vue registration site for why.
//
// shortcuts: [{ keys: ['n'], description, run(), when? }]
//   - `when` (optional) is a () => boolean guard checked in addition to the global
//     guards (not typing in a field, no modifier held, no modal open).
export function useKeyboardShortcuts(shortcuts, { isBlocked } = {}) {
  const isTypingTarget = el => {
    if (!el) return false
    const tag = el.tagName
    return el.isContentEditable || tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT'
  }

  const onKeydown = e => {
    // Never intercept modifier combos (Cmd/Ctrl/Alt) — those are the browser's.
    if (e.metaKey || e.ctrlKey || e.altKey) return
    if (isTypingTarget(e.target)) return
    if (isBlocked && isBlocked()) return

    const key = e.key.toLowerCase()
    const match = shortcuts.find(s => s.keys[0] === key)
    if (match && (!match.when || match.when())) {
      e.preventDefault()
      match.run()
    }
  }

  onMounted(() => document.addEventListener('keydown', onKeydown))
  onUnmounted(() => document.removeEventListener('keydown', onKeydown))
}
